/* eslint-disable */
// Tiny helper around the citizen session token stored in localStorage.
// Import as `import * as session from "@/utils/citizenSession"` and use
// `session.getToken()`, `session.setToken(...)`, `session.clear()`.

const TOKEN_KEY = 'ss.citizen.token';
const PHONE_KEY = 'ss.citizen.phone';
const NAME_KEY  = 'ss.citizen.name';
const EXP_KEY   = 'ss.citizen.expiresAt';

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY) || null; } catch (_) { return null; }
}
export function getPhone() {
  try { return localStorage.getItem(PHONE_KEY) || null; } catch (_) { return null; }
}
export function getName() {
  try { return localStorage.getItem(NAME_KEY) || null; } catch (_) { return null; }
}
export function isExpired() {
  try {
    const iso = localStorage.getItem(EXP_KEY);
    if (!iso) return true;
    return new Date(iso).getTime() <= Date.now();
  } catch (_) { return true; }
}
export function isAuthed() {
  return !!getToken() && !isExpired();
}
export function setSession({ token, phone, displayName, expiresAt }) {
  try {
    if (token)       localStorage.setItem(TOKEN_KEY, token);
    if (phone)       localStorage.setItem(PHONE_KEY, phone);
    if (displayName) localStorage.setItem(NAME_KEY, displayName);
    if (expiresAt)   localStorage.setItem(EXP_KEY, expiresAt);
  } catch (_) {}
}
export function clear() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(PHONE_KEY);
    localStorage.removeItem(NAME_KEY);
    localStorage.removeItem(EXP_KEY);
  } catch (_) {}
}
